import { Head, useForm } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

import LocationForm from "./_form"

interface Customer {
  id: number
  display_name: string
}

interface Option {
  id: number
  name: string
}

interface LocationData {
  name: string
  address: string
  address2: string
  city: string
  state: string
  zip: string
  phone: string
  fax: string
  email: string
  website: string
  notes: string
  sales_rep_id: number | null
}

interface Props {
  customer: Customer
  location: LocationData
  users: Option[]
  errors?: Record<string, string[]>
}

export default function New({ customer, location, users, errors }: Props) {
  const breadcrumbs: BreadcrumbItem[] = [
    { title: "Customers", href: "/customers" },
    { title: customer.display_name, href: `/customers/${customer.id}` },
    { title: "Locations", href: `/customers/${customer.id}/locations` },
    { title: "New", href: `/customers/${customer.id}/locations/new` },
  ]

  const { data, setData, post, processing, transform } = useForm({
    name: location.name,
    address: location.address,
    address2: location.address2,
    city: location.city,
    state: location.state,
    zip: location.zip,
    phone: location.phone,
    fax: location.fax,
    email: location.email,
    website: location.website,
    notes: location.notes,
    sales_rep_id: location.sales_rep_id,
  })

  transform((data) => ({ location: data }))

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post(`/customers/${customer.id}/locations`)
  }

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title={`New Location - ${customer.display_name}`} />

      <div className="p-6">
        <h1 className="mb-4 text-2xl font-semibold">New Location</h1>

        <LocationForm
          customerId={customer.id}
          data={data}
          setData={setData}
          errors={errors}
          processing={processing}
          onSubmit={handleSubmit}
          submitLabel="Create Location"
          users={users}
        />
      </div>
    </AppLayout>
  )
}
